import axios from 'axios'
import {url} from './url'
//axios.defaults.headers['Content-Type'] = 'application/json;charset=UTF-8'
const request = axios.create({
  baseURL:url,
  timeout:30000
})
request.interceptors.request.use(config=>{
  //console.log(config)
  return config
})
export {
  request
}



// WEBPACK FOOTER //
// ./src/api/request.js